import React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import setTitle from "utils/set_title";
import DataAssetsOverview from "../components/data_assets_overview";

function DataAssetsOverviewContainer() {
  setTitle("Data Assets");
  return <DataAssetsOverview />;
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        push,
      },
      dispatch,
    ),
  };
}

function select(state) {
  return {
    organisation: state.organisation,
    user: state.user,
  };
}

export default connect(select, mapDispatchToProps)(DataAssetsOverviewContainer);
